import { useQuery } from 'react-query'
import { axios } from '../../../lib'

export const loadNotifications = (data: any): Promise<any> => {
  return axios.get('/notifications', {
    params: {
      ...data
    }
  })
}

export function useLoadNotifications(query: any) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['notifications', query],
    () => loadNotifications(query),
    {
      enabled: false,
      keepPreviousData: true,
      refetchInterval: 60000
    }
  )

  return { data, error, isLoading, isFetching, isPreviousData }
}
